export default "__VITE_ASSET__897d4577__"